<template>
    <div class="preservation-pay">
        <div class="preservation-main">
            <MyTitle theTitle="交费"/>
            <iframe :src="payUrl"></iframe>
        </div>
    </div>
</template>

<script>
    import MyTitle from '../../components/common/myTitle';

    export default {
        data() {
            return {
                payUrl: '',
            }
        },
        components: {
            MyTitle
        },
        created() {
            let url = JSON.parse(sessionStorage.getItem("bqpay"));
            // window.open(url,"_self");
            this.payUrl = url;

        }
    }
</script>

<style scoped>
    .preservation-pay {
        width: 100%;
        height: 100%;
    }
</style>